module.exports = __webpack_public_path__ + "static/issues-71d6e4ee1b4a7fc075f43a9b61d4e1a2.png";